// External dependencies
import { Popper } from "@popperjs/core";
import { Dropdown, Modal } from "bootstrap";
import { Splide } from "@splidejs/splide";
import "jquery-match-height-browserify";
import "lazysizes";
import "@splidejs/splide/dist/css/splide.min.css";

// Component imports
// import "./components/select-office-by-county.js";// was used on frontpage
import "./components/office-list-filter.js";
// import "./components/office-search-niu.js;
import "./components/tag-filter.js";
import "./components/filter-search.js";
import "./components/employee-modal.js";
import "./components/scripts.js";
